import { LocalizedText } from "@/i18n/LocalizedText";
import React from "react";
import { Separator } from "./ui/separator";
import { LockOpen } from "lucide-react";
import { Button } from "./ui/button";
import { useNavigate } from "react-router-dom";

const steps = [
  {
    name: "Brand Setup",
    number: 1,
  },
  {
    name: "Prompts",
    number: 2,
  },
  {
    name: "Result",
    number: 3,
  },
];

export const AddBrandTrialDialog = ({
  setOpen,
}: {
  setOpen: (open: boolean) => void;
}) => {
  const navigate = useNavigate();
  return (
    <>
      <div className="flex justify-between text-sm opacity-50">
        {steps.map((st) => {
          return (
            <React.Fragment key={st.number}>
              <div
                className={`flex flex-col items-center text-[#393B40] px-3 md:px-0  `}
              >
                <div
                  className={`flex justify-center items-center w-[32px] h-[32px] border rounded-full border-[1.5px]  `}
                >
                  0{st.number}
                </div>
                <div
                  className={`text-[#737373] font-medium text-sm hidden md:block `}
                >
                  {st.name}
                </div>
              </div>
              {st.number < 3 && (
                <div className="grow relative translate-y-1/3">
                  <Separator className={` `} />
                </div>
              )}
            </React.Fragment>
          );
        })}
      </div>

      <div className="flex items-center flex-col gap-3 border rounded-md p-6">
        <LockOpen strokeWidth={1.5} size={32} className="text-[#F97316]" />
        <h1 className="text-lg font-semibold">
          <LocalizedText id="legacy.unlock.more.brands.co62w" />
        </h1>
        <div className="text-muted-foreground text-sm text-center">
          <LocalizedText id="legacy.track.multiple.brands.and.compare.visibility.performance.side.hk4qpn" />
        </div>
        <Button
          className="hover:bg-[#ff8138] hover:text-white text-white cursor-pointer bg-[#FF5E00]"
          onClick={() => {
            setOpen(false);
            navigate(`/dashboard/plans-pricing`);
          }}
        >
          <LocalizedText id="legacy.upgrade.now.1l1ss9v" />
        </Button>
        <Button
          variant="ghost"
          onClick={() => setOpen(false)}
          className="cursor-pointer text-muted-foreground text-xs font-normal underline underline-offset-4"
        >
          <LocalizedText id="legacy.not.now.1b3ff5y" />
        </Button>
      </div>
    </>
  );
};
